import { Query } from "@onmo/graphql/graphql";
import { meGQL, updateUserGQL } from "../graphql";
import { useMutation } from "@apollo/client/react/hooks/useMutation";
import { useQuery } from "@apollo/client/react/hooks/useQuery";
import { useLazyQuery } from "@apollo/client/react/hooks/useLazyQuery";
import { useState } from "react";
import { Regex } from "../models/regex";
import { useNavigate } from "react-router-dom";
import { showSnackbar } from "../slices/alert";
import { useAppDispatch } from "../hooks";
import { t } from "i18next";

export const useEditProfile = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { data: dataMe } = useQuery<{ me: Query["me"] }>(meGQL);
  const [fetchUser] = useLazyQuery(meGQL);
  const [updateUserMutation] = useMutation(updateUserGQL);

  const [username, setUsername] = useState<string | undefined>(
    dataMe?.me.username,
  );
  const isInvalidUsername = !Regex.isValidUsername(username || "") || !username;
  const isDisabled = isInvalidUsername || username === dataMe?.me?.username;

  const handleUsername = (value: string) => {
    setUsername(value);
  };

  const onUpdateUser = async () => {
    try {
      if (isDisabled) return;
      await updateUserMutation({
        variables: {
          input: {
            username: username?.trim(),
          },
        },
      });
      dispatch(
        showSnackbar({ message: t("profile_Profile update successfully!") }),
      );
      fetchUser({ fetchPolicy: "network-only" });
      navigate(-1);
    } catch (e) {
      console.error(e);
    }
  };

  return {
    onUpdateUser,
    handleUsername,
    username,
    isDisabled,
  };
};
